import React from 'react'
import PropTypes from 'prop-types'
import {ListItemText as RmwcListItemText} from '@rmwc/list'
import '@rmwc/list/styles'

const DrawerListItemText = ({children, ...otherProps}) => <RmwcListItemText {...otherProps}>{children}</RmwcListItemText>

DrawerListItemText.propTypes = {
  children: PropTypes.any
}

export {DrawerListItemText}
